import React from 'react';

import {WebsiteModuleProps} from "../models/website-module.props";
import {observer} from 'mobx-react';
import {SkyScrapperWrapper} from "../../../core/components/sky-scrapper/sky-scrapper.wrapper";
import {WebsiteModuleSideBar} from "./conditional/website-module.side-bar";
import {WebsiteModuleContent} from "./website-module.content";
import {SKY_SCRAPPER_OFFSET} from "../../../core/consts";
import styles from "../styles/website.module.scss";

export class WebsiteModuleBodyComponentProps extends WebsiteModuleProps {}

export const WebsiteModuleWideDesktopMain = observer(({controller}: WebsiteModuleBodyComponentProps) => {
  return (
    <SkyScrapperWrapper controller={controller} top={SKY_SCRAPPER_OFFSET.default} mainWrapperClassName={styles.sky_scrapper_container}>
      <WebsiteModuleSideBar controller={controller}/>
      <WebsiteModuleContent controller={controller}/>
    </SkyScrapperWrapper>
  );
});
